export const UPDATE_SELECTED_COLLECTION = "HOME_UI.UPDATE_SELECTED_COLLECTION";
